import { RareColors } from 'content/products/rare/productMap/constants';

// Rare product carousel data
export const RareCarouselData: Partial<
  Record<
    RareColors,
    ReadonlyArray<Record<string, string | boolean | undefined>>
  >
> = {
  [RareColors.DESERT_ROSE]: [
    {
      src: 'web_v2/rare-buy/renders/desert-rose/1-dr.png',
      srcResponsive: 'web_v2/rare-buy/renders/desert-rose/1-dr.png',
      thumb: 'web_v2/rare-buy/renders/desert-rose/1-dr.png/w_75,h_48',
      objectPositionBottom: false,
      alt: 'Desert Rose Ring - View 1',
    },
    {
      src: 'web_v2/rare-buy/renders/desert-rose/2-dr.png',
      srcResponsive: 'web_v2/rare-buy/renders/desert-rose/2-dr.png',
      thumb: 'web_v2/rare-buy/renders/desert-rose/2-dr.png/w_75,h_48',
      objectPositionBottom: false,
      alt: 'Desert Rose Ring - View 2',
    },
    {
      src: 'web_v2/rare-buy/renders/desert-rose/3-dr.png',
      srcResponsive: 'web_v2/rare-buy/renders/desert-rose/3-dr.png',
      thumb: 'web_v2/rare-buy/renders/desert-rose/3-dr.png/w_75,h_48',
      objectPositionBottom: false,
      alt: 'Desert Rose Ring - View 3',
    },
    {
      src: 'web_v2/rare-buy/renders/desert-rose/4-dr.png',
      srcResponsive: 'web_v2/rare-buy/renders/desert-rose/4-dr.png',
      thumb: 'web_v2/rare-buy/renders/desert-rose/4-dr.png/w_75,h_48',
      objectPositionBottom: true,
      alt: 'Desert Rose Ring - View 4',
    },
    {
      src: 'web_v2/rare-buy/renders/desert-rose/5-dr.png',
      srcResponsive: 'web_v2/rare-buy/renders/desert-rose/5-dr.png',
      thumb: 'web_v2/rare-buy/renders/desert-rose/5-dr.png/w_75,h_48',
      objectPositionBottom: true,
      alt: 'Desert Rose Ring - Lifestyle image - View 5',
    },
  ],
  [RareColors.DESERT_SNOW]: [
    {
      src: 'web_v2/rare-buy/renders/desert-snow/1-ds.png',
      srcResponsive: 'web_v2/rare-buy/renders/desert-snow/1-ds.png',
      thumb: 'web_v2/rare-buy/renders/desert-snow/1-ds.png/w_75,h_48',
      objectPositionBottom: false,
      alt: 'Desert Snow Ring - View 1',
    },
    {
      src: 'web_v2/rare-buy/renders/desert-snow/2-ds-updated.png',
      srcResponsive: 'web_v2/rare-buy/renders/desert-snow/2-ds-updated.png',
      thumb: 'web_v2/rare-buy/renders/desert-snow/2-ds-updated.png/w_75,h_48',
      objectPositionBottom: false,
      alt: 'Desert Snow Ring - View 2',
    },
    {
      src: 'web_v2/rare-buy/renders/desert-snow/3-ds.png',
      srcResponsive: 'web_v2/rare-buy/renders/desert-snow/3-ds.png',
      thumb: 'web_v2/rare-buy/renders/desert-snow/3-ds.png/w_75,h_48',
      objectPositionBottom: false,
      alt: 'Desert Snow Ring - View 3',
    },
    {
      src: 'web_v2/rare-buy/renders/desert-snow/4-ds.png',
      srcResponsive: 'web_v2/rare-buy/renders/desert-snow/4-ds.png',
      thumb: 'web_v2/rare-buy/renders/desert-snow/4-ds.png/w_75,h_48',
      objectPositionBottom: true,
      alt: 'Desert Snow Ring - View 4',
    },
    {
      src: 'web_v2/rare-buy/renders/desert-snow/5-ds-updated.png',
      srcResponsive: 'web_v2/rare-buy/renders/desert-snow/5-ds-updated.png',
      thumb: 'web_v2/rare-buy/renders/desert-snow/5-ds-updated.png/w_75,h_48',
      objectPositionBottom: true,
      alt: 'Desert Snow Ring - Lifestyle image - View 5',
    },
    // {
    //   src: 'web_v2/rare-buy/renders/desert-snow/6-ds-updated.png',
    //   srcResponsive: 'web_v2/rare-buy/renders/desert-snow/6-ds-updated.png',
    //   thumb: 'web_v2/rare-buy/renders/desert-snow/6-ds-updated.png/w_75,h_48',
    //   objectPositionBottom: true,
    //   alt: 'Desert Snow Ring - Lifestyle image - View 6',
    // },
  ],
  [RareColors.DUNE]: [
    {
      src: 'web_v2/rare-buy/renders/dune/1-dn.png',
      srcResponsive: 'web_v2/rare-buy/renders/dune/1-dn.png',
      thumb: 'web_v2/rare-buy/renders/dune/1-dn.png/w_75,h_48',
      objectPositionBottom: false,
      alt: 'Dune Ring - View 1',
    },
    {
      src: 'web_v2/rare-buy/renders/dune/2-dn.png',
      srcResponsive: 'web_v2/rare-buy/renders/dune/2-dn.png',
      thumb: 'web_v2/rare-buy/renders/dune/2-dn.png/w_75,h_48',
      objectPositionBottom: false,
      alt: 'Dune Ring - View 2',
    },
    {
      src: 'web_v2/rare-buy/renders/dune/3-dn.png',
      srcResponsive: 'web_v2/rare-buy/renders/dune/3-dn.png',
      thumb: 'web_v2/rare-buy/renders/dune/3-dn.png/w_75,h_48',
      objectPositionBottom: false,
      alt: 'Dune Ring - View 3',
    },
    {
      src: 'web_v2/rare-buy/renders/dune/4-dn.png',
      srcResponsive: 'web_v2/rare-buy/renders/dune/4-dn.png',
      thumb: 'web_v2/rare-buy/renders/dune/4-dn.png/w_75,h_48',
      objectPositionBottom: true,
      alt: 'Dune Ring - View 4',
    },
    {
      src: 'web_v2/rare-buy/renders/dune/5-dn.png',
      srcResponsive: 'web_v2/rare-buy/renders/dune/5-dn.png',
      thumb: 'web_v2/rare-buy/renders/dune/5-dn.png/w_75,h_48',
      objectPositionBottom: true,
      alt: 'Dune Ring - Lifestyle image - View 5',
    },
  ],
};

// Rare product data and utilities
export const RARE_PRODUCT_DATA = {
  colors: [
    {
      id: 'desert-rose',
      name: 'Desert Rose',
      thumb: 'web_v2/rare-buy/renders/desert-rose/3-dr.png/w_75,h_48',
    },
    {
      id: 'desert-snow',
      name: 'Desert Snow',
      thumb: 'web_v2/rare-buy/renders/desert-snow/3-ds.png/w_75,h_48',
    },
    {
      id: 'dune',
      name: 'Dune',
      thumb: 'web_v2/rare-buy/renders/dune/3-du.png/w_75,h_48',
    },
  ],
};

export const RARE_PRODUCT_CONFIG = {
  // Add configuration options
};

// Rare product contents data for "What's in the box" section
export const RARE_CONTENTS_DATA = [
  {
    image: 'web_v2/rare-buy/renders/illustrations/content-rare.png/w_800',
    title: 'Ultrahuman Ring Rare',
  },
  {
    image: 'web_v2/rare-buy/renders/illustrations/rare-charger.png/w_800',
    title: 'Ring Rare Charger',
  },
  {
    image: 'web_v2/rare-buy/renders/illustrations/rare-cable.png/w_800',
    title: 'Type-C to C Cable (1 mtr)',
  },
  {
    image: 'web_v2/rare-buy/renders/illustrations/certidicate-updated.png/w_800',
    title: 'Certificate of Authenticity',
  },
];
